export const PDPA2B = 'PDPA2B';
export const REGA2B = 'REGA2B';
export const PDPUB = 'PDPUB';
export const SOURCE_ACTION_MAP = {
  [PDPUB]: PDPA2B,
};
